var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.93074 13.7241H0.0341797V16H6.93074V13.7241Z",
    fill: "#303743"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93074 9.17239H0.0341797V11.4483H6.93074V9.17239Z",
    fill: "#303743"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93074 4.55173H0.0341797V6.8276H6.93074V4.55173Z",
    fill: "#303743"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93074 0H0.0341797V2.27588H6.93074V0Z",
    fill: "#303743"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9653 13.7241H9.1377V16H15.9653V13.7241Z",
    fill: "#303743"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9653 9.17239H9.1377V11.4483H15.9653V9.17239Z",
    fill: "#303743"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9653 4.55173H9.1377V6.8276H15.9653V4.55173Z",
    fill: "#303743"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9653 0H9.1377V2.27588H15.9653V0Z",
    fill: "#303743"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.f7706d65f3bd3cf5e9bf5d0d7e10a0f1.svg";
export { ForwardRef as ReactComponent };